module.exports = __webpack_public_path__ + "media/images/common/medium_off-d89157e58a6df61f2d89445edfc85756.gif";